import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../../feature.types";
import { buildCrudPermissions, permissionId } from "../../../shared/featureFactories";

function buildViewOnlyPermissions(action: string) {
  return { view: action, create: action, edit: action, delete: action };
}

export const IncomeExpenditureFeature: FeatureMetadata = {
  id: "accounts-income-expenditure",
  moduleName: "feesFinance",
  navigation: {
    label: "Transactions Summary",
    path: "/accounts/income-expenditure",
    icon: DocumentTextIcon,
    order: 2,
    parentId: "accounts",
  },
  route: {
    path: "/accounts/income-expenditure",
    element: lazy(() => import("./pages/IncomeExpenditurePage")),
  },
  permissions: buildCrudPermissions(
    "FeeFinance",
    "Accounts",
    buildViewOnlyPermissions(permissionId("FeeFinance", "Accounts", "incomeExpenditure")),
  ),
  readiness: "live",
};
